import { barcodeLabelSize } from "@redotech/redo-inventory-common/barcode-label";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  barcodeLabelSize as licensePlateLabelSize,
  type BarcodeLabelSize as LicensePlateLabelSize,
} from "@redotech/redo-inventory-common/barcode-label";

export const printLicensePlate = {
  name: "printLicensePlate" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    labelSize: z.enum(barcodeLabelSize).optional(),
    printerId: z.number().optional(),
    printerOptions: z.record(z.string(), z.unknown()).optional(),
    printInventoryLabel: z.boolean().optional(),
    print3plLabel: z.boolean().optional(),
  }),
  output: z.object({
    inventoryPdfDataUrl: z.string().optional(),
    threePlPdfDataUrl: z.string().optional(),
    receivingPdfDataUrl: z.string().optional(),
    inventoryItemId: inventoryItemIdFormat.schema,
    barcodeValue: z.string(),
    sku: z.string().nullable(),
    printed: z.boolean().optional(),
    /** The latest walk moved the unit onto another product, so its old product label is wrong. */
    productTransformed: z.boolean().optional(),
  }),
};
